import { render, staticRenderFns } from "./Postmark.vue?vue&type=template&id=4d2f0016&scoped=true"
import script from "./Postmark.vue?vue&type=script&lang=js"
export * from "./Postmark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f0016",
  null
  
)

export default component.exports